<div class="datacenter-filter-date">
	<label class="filter-date-label" for="filter-date-input">{{label}}</label>
	<div class="filter-date-wraper">
		<mat-form-field class="no-padding" appearance="outline">
			<input class="filter-date-input"
				matInput
				id="filter-date-input"
				spellcheck="false"
				autocomplete="off"
				[placeholder]="'filter.date' | translate"
				[copoDatepicker]="datepicker"
				[copoFormat]="formatType"
				[formControl]="dateControl"
				(click)="datepicker.open()"
				#dateInput
				(dateChange)="onDateChange()"
				(typeChange)="onTypeChange()">
			<button type="button" *ngIf="dateControl.value" matSuffix mat-icon-button (click)="resetDate();" tabindex="-1">
				<mat-icon svgIcon="md:close" class="copo-small-close"></mat-icon>
			</button>
			<mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
			<!-- About ag-custom-component-popup: https://www.ag-grid.com/javascript-data-grid/component-filter/#custom-filters-containing-a-popup-element-->
			<mat-datepicker panelClass="ag-custom-component-popup" #datepicker [startAt]="dateControl!.value"></mat-datepicker>
		</mat-form-field>
	</div>
</div>